import { DISCOUNT_TYPE } from '../../../../interfaces';
import { E_CURRENCY, IPriceConfig, TCurrency } from '../../../pricing/interfaces';
import { Price } from '../../../pricing/utils';

type GetDiscountTextParams = {
  value: number;
  discountType: typeof DISCOUNT_TYPE[number];
  priceConfig?: IPriceConfig;
  currency?: TCurrency;
};

export const getDiscountText = (params: GetDiscountTextParams): string => {
  const { value, discountType, priceConfig, currency = E_CURRENCY.USD } = params;
  if (discountType === 'fix') {
    return new Price(value, currency).toLocalString(null, priceConfig)
  }

  return `${value}%`;

};
